// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Checkbox__checkboxContainer__b17aaf5607067c135b68"};